import { SchemaField } from '../../../../generic/serialization/schema-field';
import { CommunicationWidgetSchema } from '../../generic/communication-widget/communication-widget-schema';

export class CommunicationWidgetOfferReservationSchema extends CommunicationWidgetSchema {
  public static readonly allowSpeech = 'allowSpeech';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly type = undefined;

    public static readonly description = 'missing-description';

    public static readonly displayName = 'missing-displayName';

    public static readonly allowSpeech = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Schema for this object is encoded into a command name, and in parameters
   */
  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[CommunicationWidgetOfferReservationSchema.allowSpeech] = SchemaField.boolean(
      CommunicationWidgetOfferReservationSchema.Defaults.allowSpeech,
    ).required();
    /* eslint-enable */

    return parameters;
  }
}
